import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpRightSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 34 34"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.242 19.829.001 1 2-.001v-1l-.004-7.075v-1h-1l-7.068.004-1 .001.001 2h1l4.659-.003-7.339 7.339-.707.707 1.414 1.414.707-.707 7.334-7.334.003 4.655Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpRightSharp);
export default Memo;
